import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RedirectService {
  private redirectUrl: string | null = null;

  setRedirectUrl(url: string): void {
    this.redirectUrl = url;
    // console.log('setRedirectUrl', url);
  }

  getRedirectUrl(): string | null {
    return this.redirectUrl;
  }

  clearRedirectUrl(): void {
    const url = this.redirectUrl;
    this.redirectUrl = null;
    // console.log('clearRedirectUrl', url);
  }

  hasRedirectUrl(): boolean {
    return !!this.redirectUrl;
  }
}
